var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSave(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.495,
    height: 13.839,
    viewBox: "0 0 18.495 13.839",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Save",
    transform: "translate(-354.252 -684.582)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2975",
    "data-name": "Group 2975"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2790",
    "data-name": "Path 2790",
    d: "M372.247,689.267H354.752v-2.022h16.84a.638.638,0,0,1,.64.641v1.381Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2791",
    "data-name": "Path 2791",
    d: "M354.752,687.231v10.021a.662.662,0,0,0,.655.655h16.185a.663.663,0,0,0,.655-.655v-9.38a.663.663,0,0,0-.655-.655H360.987",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2792",
    "data-name": "Path 2792",
    d: "M360.987,687.231h-6.235v-2.149h4.669a1.2,1.2,0,0,1,1.153.854Z",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2793",
    "data-name": "Path 2793",
    d: "M366.382,693.537h-5.765a1.271,1.271,0,0,0-1.267,1.267v3.117h8.285V694.8A1.249,1.249,0,0,0,366.382,693.537Z",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSave);
export default __webpack_public_path__ + "static/media/Save.6bbd32b92554df4a9b7a44c0fc0fc938.svg";
export { ForwardRef as ReactComponent };